import { useState, useEffect } from 'react';

export function useOnScreen(ref, threshold = 0) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const elementRefCopy = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        threshold,
      }
    );

    if (elementRefCopy) {
      observer.observe(elementRefCopy);
    }

    return () => {
      observer.unobserve(elementRefCopy);
    };
  }, [ref, threshold]);

  return { isIntersecting };
}
